export default "__VITE_ASSET__DFPZYxeO__"